// Baseline export columns that never appear in the bulk-import schema.
// Their presence in a header row uniquely identifies a "Download Data" export file.
// Source of truth: eid-insurance .../export/CsvExportHeaders.scala (BaselineHeaders).
export const EXPORT_SIGNATURE_HEADERS: string[] = [
    'Active',
    'Paused',
    'Effective Group',
    'Expiration',
    'Verification Status',
    'Compliance Status',
    'Latest Submission Date',
];

// The export writes the standard address sub-fields with bare labels, while the
// import expects "Entity Address *" labels. This is the ONLY hard label coupling.
// If a baseline header is renamed in CsvExportHeaders.scala, update this map.
export const ADDRESS_LABEL_ALIASES: Record<string, string> = {
    'Country': 'Entity Address Country',
    'Street': 'Entity Address Street Address',
    'Apt Suite or Unit': 'Entity Address Apt, Suite or Unit',
    'City': 'Entity Address City',
    'State': 'Entity Address State',
    'Zip code': 'Entity Address Zip',
};

// Canonical import label for the doing-business-as column.
export const DBA_LABEL = 'DBA Name(s)';
